(function () {
    'use strict';

    function range() {
        return function (value, min, max) {
            return _.range(min, max);
        };
    }

    angular.module('ecap.common').filter('range', range);
})();